<template>
  <div class="textarea">
    <label>{{ label }}</label>
    <textarea
      class="txta"
      id="textarea"
      :class="styles"
      :name="name"
      :value="value"
      @input="$emit('input', $event.target.value)"
      :placeholder="placeholder"
      :rows="rows"
      :cols="cols"
      :readonly="readonly"
      :disabled="disabled"
    ></textarea>
  </div>
</template>

<script>
export default {
  name: "Textarea",
  props: [
    "placeholder",
    "label",
    "name",
    "value",
    "rows",
    "styles",
    "readonly",
    "disabled",
    "cols"
  ]
};
</script>

<style scoped>
.textarea {
  position: relative;
  margin-bottom: 2px;
  margin-top: 16px;
  height: auto;
}
label {
  font-weight: 500;
  font-size: var(--fs-sm);
  line-height: 1.4;
  color: var(--muted);
  font-family: var(--font-sans);
}
textarea {
  margin-top: 6px;
  padding: 10px 12px;
  outline: none;
  box-sizing: border-box;
  border-radius: var(--radius-md);
  display: block;
  font-size: var(--fs-body);
  line-height: 1.5;
  color: var(--text);
  background: var(--surface);
  border: 1px solid var(--line);
  width: 100%;
  max-width: 100%;
  resize: none;
  font-family: var(--font-sans);
  transition: border-color var(--dur) var(--ease),
    box-shadow var(--dur) var(--ease);
}
textarea:focus {
  outline: none;
  border-color: var(--accent-600);
  box-shadow: var(--ring);
}
textarea:disabled {
  background: var(--surface-2);
  color: var(--muted-soft);
  cursor: not-allowed;
}
.is-active {
  padding-left: 20px !important;
}
textarea::placeholder {
  font-size: var(--fs-body);
  color: var(--muted-soft);
}
</style>
